import { render, staticRenderFns } from "./DeleteConfirmComp.vue?vue&type=template&id=14782974&scoped=true&"
import script from "./DeleteConfirmComp.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirmComp.vue?vue&type=script&lang=js&"
import style0 from "./DeleteConfirmComp.vue?vue&type=style&index=0&id=14782974&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14782974",
  null
  
)

export default component.exports